"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _dec, _class;

require("source-map-support/register");

var _tsyringe = require("tsyringe");

var singleton = _tsyringe.singleton;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Env = (_dec = singleton(), _dec(_class = /*#__PURE__*/function () {
  function Env() {
    _classCallCheck(this, Env);
  }

  _createClass(Env, [{
    key: "getValue",
    value: function getValue(key, defaultValue) {
      if (!process.env[key]) {
        if (!defaultValue) throw new Error("Missing ".concat(key, " in process.env"));
        return defaultValue;
      }

      return process.env[key];
    }
  }]);

  return Env;
}()) || _class);
exports["default"] = Env;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9IZWxwZXIvRW52LnRzIl0sIm5hbWVzIjpbInNpbmdsZXRvbiIsIkVudiIsImtleSIsImRlZmF1bHRWYWx1ZSIsInByb2Nlc3MiLCJlbnYiLCJFcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7SUFBU0EsUyxhQUFBQSxTOzs7Ozs7OztJQUdZQyxHLFdBRHBCRCxTQUFTLEU7Ozs7Ozs7NkJBRUNFLEcsRUFBYUMsWSxFQUErQjtBQUNuRCxVQUFJLENBQUNDLE9BQU8sQ0FBQ0MsR0FBUixDQUFZSCxHQUFaLENBQUwsRUFBdUI7QUFDckIsWUFBSSxDQUFDQyxZQUFMLEVBQW1CLE1BQU0sSUFBSUcsS0FBSixtQkFBcUJKLEdBQXJCLHFCQUFOO0FBQ25CLGVBQU9DLFlBQVA7QUFDRDs7QUFFRCxhQUFPQyxPQUFPLENBQUNDLEdBQVIsQ0FBWUgsR0FBWixDQUFQO0FBQ0Q7Ozs7O3FCQVJrQkQsRyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHNpbmdsZXRvbiB9IGZyb20gJ3RzeXJpbmdlJztcblxuQHNpbmdsZXRvbigpXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBFbnYge1xuICBnZXRWYWx1ZShrZXk6IHN0cmluZywgZGVmYXVsdFZhbHVlPzogc3RyaW5nKTogc3RyaW5nIHtcbiAgICBpZiAoIXByb2Nlc3MuZW52W2tleV0pIHtcbiAgICAgIGlmICghZGVmYXVsdFZhbHVlKSB0aHJvdyBuZXcgRXJyb3IoYE1pc3NpbmcgJHtrZXl9IGluIHByb2Nlc3MuZW52YCk7XG4gICAgICByZXR1cm4gZGVmYXVsdFZhbHVlO1xuICAgIH1cblxuICAgIHJldHVybiBwcm9jZXNzLmVudltrZXldIGFzIHN0cmluZztcbiAgfVxufVxuIl19